<div id="not-found">
  <div *ngIf="! customMessage; else elseBlock" class="db-error-section">
    <p>Page not found!</p>
  </div>
  <ng-template #elseBlock>
    <div [innerHTML]="(customMessage || '') | safeHtml" class="db-error-section">
      {{ customMessage }}
    </div>
  </ng-template>
</div>
